import Icon from "@mdi/react";
import styled from "@emotion/styled";
import React, { FC } from "react";
import { Typography } from "@material-ui/core";
import { mdiCloudUpload } from "@mdi/js";
import { useDropzone } from "react-dropzone";

type DropZoneProps = {
  explanatoryText: string;
  sampleLink: string;
  onDrop: (acceptedFiles: any) => void;
  didErrorOccurInUpload: boolean;
};

const StyledDropzone = styled.section`
  flex: 1;
  height: 16rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 4px 4px 4px;
  border-width: 3px;
  border-radius: 4px;
  border-color: #0083ef;
  border-style: dashed;
  background-color: #fafafa;
  color: black;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
`;

const DropZone: FC<DropZoneProps> = ({ explanatoryText, sampleLink, onDrop, didErrorOccurInUpload }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ".csv",
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        // marginTop: "2rem",
        marginBottom: "2rem",
      }}
    >
      <input {...getInputProps()} />
      <StyledDropzone className="styledDropzone m-auto text-center mt-5 mb-5">
        <Icon className="w-100" path={mdiCloudUpload} title="Image Upload" size={3} color="#0083EF" />
        <Typography className="mt-5" variant="h6">
          Drag and drop or
          <span className="ml-3 bg-primary p-2 text-white rounded">SELECT FROM YOUR COMPUTER</span>
        </Typography>
        {didErrorOccurInUpload ? (
          <Typography variant="body1" className="text-danger text-center mt-4">
            There was an error uploading your file. Please try again.
          </Typography>
        ) : (
          <Typography variant="body1" className="text-center mb-4 mt-4">
            {explanatoryText}{" "}
          </Typography>
        )}
      </StyledDropzone>
      <span
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1rem",
          fontSize: "1rem",
        }}
      >
        <button
          style={{
            backgroundColor: "transparent",
            border: "none",
            color: "#0083EF",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          type="button"
          onClick={() => {
            window.open(sampleLink, "_blank");
          }}
        >
          Sample CSV file{" "}
        </button>
      </span>
    </div>
  );
};

export default DropZone;
